(function () {
  'use strict';

  var STORAGE_KEY = 'easyusa:favorites:v1';
  var MAX_ITEMS = 80;
  var config = window.EasyUSAFavoritesConfig || {};
  var syncTimer;

  function readFavorites() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(items) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
  }

  function normalize(value) {
    return String(value || '').trim();
  }

  function escapeHtml(value) {
    return normalize(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function favoriteKey(item) {
    return normalize(item.productId || item.handle || item.url);
  }

  function getCurrentVariantId(button) {
    var scope = button.closest('.pdp-summary, .pdp-purchase, .eu-pdp, .product-thumb') || document;
    var variantInput = scope.querySelector('input[name="id"], [id^="eu-variant-id-"]');
    return normalize(variantInput ? variantInput.value : button.dataset.variantId);
  }

  function getProductData(button) {
    var variantId = getCurrentVariantId(button);
    var baseUrl = normalize(button.dataset.productBaseUrl);
    var url = normalize(button.dataset.productUrl || window.location.pathname);
    if (baseUrl && variantId) {
      url = baseUrl + (baseUrl.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + encodeURIComponent(variantId);
    }
    return {
      productId: normalize(button.dataset.productId),
      variantId: variantId,
      handle: normalize(button.dataset.productHandle),
      title: normalize(button.dataset.productTitle),
      url: url,
      image: normalize(button.dataset.productImage),
      price: normalize(button.dataset.productPrice),
      type: normalize(button.dataset.productType),
      hasVariants: button.dataset.hasVariants === 'true',
      savedAt: Date.now()
    };
  }

  function isSaved(productId) {
    var id = normalize(productId);
    if (!id) return false;
    return readFavorites().some(function (item) {
      return normalize(item.productId) === id;
    });
  }

  function setButtonState(button, active) {
    button.classList.toggle('is-favorited', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = button.querySelector('[data-favorite-label]');
    if (label) label.textContent = active ? 'Saved' : 'Save';
    button.setAttribute('aria-label', (active ? 'Remove ' : 'Save ') + normalize(button.dataset.productTitle) + (active ? ' from favorites' : ' to favorites'));
  }

  function syncButtons() {
    document.querySelectorAll('[data-eu-favorite-button]').forEach(function (button) {
      setButtonState(button, isSaved(button.dataset.productId));
    });
    updateCount();
  }

  function toggleFavorite(button) {
    var item = getProductData(button);
    var key = favoriteKey(item);
    if (!key) return;

    var items = readFavorites();
    var existingIndex = items.findIndex(function (saved) {
      return favoriteKey(saved) === key;
    });

    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
    } else {
      items.unshift(item);
    }

    writeFavorites(items);
    syncButtons();
    scheduleServerSync();
  }

  function updateCount() {
    return readFavorites().length;
  }

  function scheduleServerSync() {
    if (!config.endpoint || !config.loggedIn) return;
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncToServer, 350);
  }

  // Sync failures were previously swallowed entirely (empty .catch), so a
  // 401 from a bad signature/session, a network error, or a Vercel 500 all
  // looked identical to "worked fine" — favorites just silently stayed
  // local-only with zero trace of why. Logging here doesn't fix any
  // particular cause, but makes the actual reason visible in devtools
  // instead of requiring guesswork every time this gets reported again.
  function logSyncIssue(action, response, data) {
    var status = response ? response.status : 'network error';
    var reason = data && data.error ? data.error : (data && !data.ok ? 'ok:false, no error message' : 'unexpected response shape');
    console.warn('[easyusa-favorites] ' + action + ' failed:', status, reason);
  }

  function syncToServer() {
    if (!config.endpoint || !config.loggedIn) return;

    var lastResponse;
    fetch(config.endpoint, {
      method: 'PUT',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ favorites: readFavorites() })
    })
      .then(function (response) {
        lastResponse = response;
        return response.json();
      })
      .then(function (data) {
        if (!data.ok || !Array.isArray(data.favorites)) {
          logSyncIssue('save (PUT)', lastResponse, data);
          return;
        }
        writeFavorites(data.favorites);
        syncButtons();
      })
      .catch(function (err) {
        console.warn('[easyusa-favorites] save (PUT) failed: network/parse error', err);
      });
  }

  function mergeFromServer() {
    if (!config.endpoint || !config.loggedIn) return;

    var lastResponse;
    fetch(config.endpoint, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        lastResponse = response;
        return response.json();
      })
      .then(function (data) {
        if (!data.ok || !Array.isArray(data.favorites)) {
          logSyncIssue('load (GET)', lastResponse, data);
          return;
        }

        var local = readFavorites();
        var serverKeys = {};
        data.favorites.forEach(function (item) { serverKeys[favoriteKey(item)] = true; });

        // Union: server is authoritative for items it already knows about;
        // keep any local-only items (saved on this device, not yet synced)
        // and push the combined set back up so neither side loses data.
        var localOnly = local.filter(function (item) { return !serverKeys[favoriteKey(item)]; });
        var merged = data.favorites.concat(localOnly);

        writeFavorites(merged);
        syncButtons();

        if (localOnly.length) scheduleServerSync();
      })
      .catch(function (err) {
        console.warn('[easyusa-favorites] load (GET) failed: network/parse error', err);
      });
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var favoriteButton = event.target.closest('[data-eu-favorite-button]');
      if (favoriteButton) {
        event.preventDefault();
        event.stopPropagation();
        toggleFavorite(favoriteButton);
        return;
      }

    });

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) {
        syncButtons();
      }
    });
  }

  function injectStyles() {
    if (document.getElementById('easyusa-favorites-styles')) return;
    var style = document.createElement('style');
    style.id = 'easyusa-favorites-styles';
    style.textContent =
      '.eu-favorite-btn{display:inline-flex;align-items:center;justify-content:center;gap:6px;border:1px solid rgba(18,49,79,.16);border-radius:999px;background:rgba(255,255,255,.92);color:#12314f;font:800 11px/1 var(--eu-font-body,var(--font-body--family,Arial,sans-serif));letter-spacing:.04em;text-transform:uppercase;box-shadow:0 8px 22px rgba(18,49,79,.12);cursor:pointer;transition:background 160ms ease,color 160ms ease,border-color 160ms ease,transform 160ms ease}' +
      '.eu-favorite-btn::before{content:"\\2665";font-size:13px;line-height:1;color:#7a8da2;transition:color 160ms ease}' +
      '.eu-favorite-btn:hover{transform:translateY(-1px);border-color:#3b90da}' +
      '.eu-favorite-btn.is-favorited{background:#12314f;border-color:#12314f;color:#fff}' +
      '.eu-favorite-btn.is-favorited::before{color:#fff}' +
      '.eu-card-favorite{position:absolute;top:12px;right:12px;bottom:auto;left:auto;z-index:12;width:32px;height:32px;min-height:0;padding:0}' +
      '.eu-card-favorite::before{font-size:15px}' +
      '.eu-card-favorite [data-favorite-label]{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}' +
      '.eu-pdp-favorite{min-height:36px;padding:10px 14px;margin-left:auto}' +
      '@media(max-width:767px){.eu-pdp-favorite{width:100%;margin-left:0}.eu-card-favorite{width:28px;height:28px}}';
    document.head.appendChild(style);
  }

  function init() {
    injectStyles();
    bindEvents();
    syncButtons();
    mergeFromServer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
